import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/changeai.webp';
import screenshot_target from '../../../images/letterfunnel/peterharmschalk.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Peter-Harm Schalk"
      firstname="Peter-Harm"
      companyname="Change AI"
      competition="Concentrix en RIFF"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/peterharmschalk.js